import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ToastService } from 'src/app/shared/service/toast.service';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationGuard implements CanActivate {
  constructor(private router: Router, private toastService: ToastService) {}

  canActivate(): boolean {
    const email = localStorage.getItem('emailCodijobsRegister');
    if (!email) {
      this.toastService.showMessages('error', [
        'No se encontró el correo de registro. Intenta registrarte nuevamente.',
      ]);
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
